import * as actions from './actionTypes';
import {CHAINS, getWalletInfoByName, IChain, IWallet, WALLETS} from 'src/contract/config';
import { UseOperator } from "../hooks/UseOperator";
import { SET_isOperator } from "./actionTypes";

export type IState = {
    address: string,
    network: IChain | null,
    wallet_info: IWallet | null,
    isOperator: boolean,
    isAdmin: boolean,
};
let initState: IState = {
    //address: sessionStorage.getItem("wallet_address") || (getWalletProvider() && getWalletProvider().selectedAddress) || "",
    address: sessionStorage.getItem("wallet_address") || "",
    network: null,
    wallet_info: getWalletInfoByName(sessionStorage.getItem("wallet_name") || ""),
    isOperator: false,
    isAdmin: false
};

export default function reducer(state = initState, action: any): IState  {
    switch (action.type) {
        case actions.SET_WALLET_ADDRESS:
            return {...state, address: action.data};
        case actions.SET_NETWORK:
            return {...state, network: action.data};
        case actions.SET_WALLET_INFO:
            return {...state, wallet_info: action.data};
        case actions.SET_isOperator:
            return {...state, isOperator: action.data};
        case actions.SET_isAdmin:
            return {...state, isAdmin: action.data};
        default:
            return state;
    }
}
